module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_phone-fbd74d07bc62173ead691f6fa92efe45.svg";